<tui-hosted-dropdown
    class="t-wrapper"
    [content]="picker"
    [(open)]="open"
>
    <tui-primitive-textfield
        class="t-textfield"
        [tuiTextfieldIconLeft]="color"
        [pseudoFocus]="computedFocused"
        [pseudoHover]="pseudoHover"
        [pseudoActive]="pseudoActive"
        [invalid]="computedInvalid"
        [focusable]="focusable"
        [nativeId]="nativeId"
        [disabled]="disabled"
        [readOnly]="readOnly"
        [(value)]="value"
        (focusedChange)="onFocused($event)"
    >
        <ng-content></ng-content>
    </tui-primitive-textfield>
</tui-hosted-dropdown>

<ng-template #color>
    <div
        class="t-color"
        [style.background]="background"
    ></div>
</ng-template>

<ng-template
    #picker
    let-activeZone
>
    <tui-color-selector
        [tuiActiveZoneParent]="activeZone"
        [colors]="colors"
        [(color)]="value"
    ></tui-color-selector>
</ng-template>
